import { requestGet } from '../utils/request';
import { toQueryString } from '../utils/queryString';

const BASE_HISTORICAL_URL = '/api/weather/v3/historical-values/fields';
const PRECISION_DIGITS = 2;
const DEFAULT_END_DATE = `${new Date().getFullYear()}-12-31`;

// If FF -> web.microsoft-weather-gdd enabled, use v4, otherwise stay with v3.
const getObservationsUrl = (version = "v3") => `/api/weather/${version}/season-observations/fields`;

/**
 * Get Historical Weather Data
 * @param {String} fieldId
 * @param {String} startDate
 * @param {String} endDate
 * @return {Promise} Response
 */
export function requestHistoricalValues(
  fieldId,
  startDate = '2011-01-01',
  endDate = DEFAULT_END_DATE
) {
  const queryParams = toQueryString({
    variables: 'precip',
    'end-date': endDate,
    'start-date': startDate,
    'field-ids': fieldId,
    precision: PRECISION_DIGITS,
  });
  const url = `${BASE_HISTORICAL_URL}?${queryParams}`;
  return requestGet(url, {
    mockFile: 'weather/precipitation',
  });
}

/**
 * Get Nistorical Weather Data
 * @param {String} fieldId
 * @param {String} season
 * @return {Promise} Response
 */
export function requestObservationsValues(fieldId, season, useV4 = false) {
  const year = season.split(':')[0];
  const endDate = `${year}-12-31`;

  const queryParams = toQueryString({
    variables: 'gdu_accumulated',
    'field-ids': fieldId,
    ...(useV4 ? { year } : { precision: PRECISION_DIGITS, date: endDate })
  });

  const observationsVersion = useV4 ? "v4" : "v3"; // v4 is Microsoft integration
  const url = `${getObservationsUrl(observationsVersion)}?${queryParams}`;
  const headers = useV4 ? { headers: { 'x-stub': false } } : { };

  return requestGet(url, headers);
}
